const LANDING_EXPERIMENT = 'landing_logan_work_done_v5';
const STORAGE_KEY = `glowup_experiment_${LANDING_EXPERIMENT}`;
const VARIANTS = ['free_forever', 'voc_relief'];

const safeStorage = () => (
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
    ? window.localStorage
    : null
);

const queryOverride = (location) => {
  if (!location) return '';
  const value = new URLSearchParams(location.search).get('landing_variant') || '';
  return VARIANTS.includes(value) ? value : '';
};

export const isLandingExperimentEligible = (location) => {
  if (!location) return false;
  const medium = (new URLSearchParams(location.search).get('utm_medium') || '').toLowerCase();
  return location.hostname === 'glowup.botmo.io'
    && location.pathname === '/'
    && ['cpc', 'ppc', 'paid', 'paid_social', 'display'].includes(medium);
};

export const getOrAssignLandingVariant = (
  randomValue = Math.random(),
  location = typeof window !== 'undefined' ? window.location : null,
) => {
  const storage = safeStorage();
  const override = queryOverride(location);
  if (override) {
    try { storage?.setItem(STORAGE_KEY, override); } catch { /* fail open */ }
    return override;
  }

  try {
    const stored = storage?.getItem(STORAGE_KEY) || '';
    if (VARIANTS.includes(stored)) return stored;
  } catch {
    // Storage can be blocked. The page still needs a stable value this render.
  }

  // Keep organic visits and every white-label host on the proven free offer.
  // Only new paid Glowup traffic joins the 50/50 message test.
  if (!isLandingExperimentEligible(location)) return 'free_forever';

  const assigned = Number(randomValue) < 0.5 ? VARIANTS[0] : VARIANTS[1];
  try { storage?.setItem(STORAGE_KEY, assigned); } catch { /* fail open */ }
  return assigned;
};

export const getLandingExperimentContext = () => {
  try {
    const variant = safeStorage()?.getItem(STORAGE_KEY) || '';
    if (!VARIANTS.includes(variant)) return {};
    return {
      landing_experiment: LANDING_EXPERIMENT,
      landing_variant: variant,
    };
  } catch {
    return {};
  }
};

export const landingExperimentName = LANDING_EXPERIMENT;
